import React, { useMemo } from 'react';
import {
  ANDTag,
  Container,
  EventNameWrapper,
  MappingRules,
  MappingRulesContainer,
  ORTag,
  RulesBuilderContainer,
} from '@src/emp-3.0/components/MappedEventDetail/styled';
import { formatOperator } from '@src/emp-3.0/utils';
import { useGetDimensionsList } from '@api/common/queryHooks';

const TransformRulesRender = ({ rules }) => {
  const { data: dimensionList } = useGetDimensionsList();

  const metadataNameMap = useMemo(() => {
    return (dimensionList?.data ?? []).reduce((acc, { dimension_name, display_name }) => {
      if (dimension_name) {
        acc[dimension_name] = display_name;
      }
      return acc;
    }, {});
  }, [dimensionList?.data]);

  return (
    <Container>
      <div>Mapping Rules</div>
      <RulesBuilderContainer>
        {rules?.map((item, index) => {
          const metadataName = metadataNameMap?.[item?.source_dimension] ?? item?.source_dimension;
          const itemLabel =
            index === 0 ? (
              'When'
            ) : (
              <ANDTag as="div" style={{ backgroundColor: '#000', color: '#fff' }}>
                AND
              </ANDTag>
            );
          return (
            <div key={`${item.source_dimension}_${index}`}>
              <EventNameWrapper>
                <span style={{ padding: '8px' }}>{itemLabel}</span>
                <span style={{ padding: '8px', fontWeight: 500 }}>Metadata Name * :</span>
                <span style={{ padding: '8px 12px 8px 4px', color: 'rgba(0, 0, 0, 0.88)' }}>
                  {metadataName}
                </span>
              </EventNameWrapper>
              {item?.rule?.map((andRules, andIndex) => {
                return (
                  <MappingRulesContainer key={`andMetadataRules_${andIndex}`}>
                    {andRules?.map((orRule, orIndex) => {
                      const mappingRulesLabel = (
                        <span
                          style={{
                            width: '80px',
                            display: 'flex',
                            flexShrink: 0,
                            justifyContent: andIndex !== 0 && orIndex === 0 ? 'normal' : 'end',
                          }}
                        >
                          {andIndex === 0 && orIndex === 0 ? (
                            ''
                          ) : orIndex === 0 ? (
                            <ANDTag>AND</ANDTag>
                          ) : (
                            <ORTag>OR</ORTag>
                          )}
                        </span>
                      );
                      return (
                        <MappingRules key={`orMetadataRules_${orIndex}`}>
                          {mappingRulesLabel}
                          <span style={{ color: 'rgba(0, 0, 0, 0.88)', whiteSpace: 'nowrap' }}>
                            {metadataName}
                          </span>
                          <span>{formatOperator(orRule.op)}</span>
                          <span style={{ color: 'rgba(0, 0, 0, 0.88)', textAlign: 'left' }}>
                            {orRule.value.join(',')}
                          </span>
                        </MappingRules>
                      );
                    })}
                  </MappingRulesContainer>
                );
              })}
            </div>
          );
        })}
      </RulesBuilderContainer>
    </Container>
  );
};

export default TransformRulesRender;
